// Multi-user Accounts Utility for SpeedoTube Cross-User Ecosystem
import { getAvatarColor } from './avatarUtils';

export const PRIMARY_VALID_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTQ3LCJpYXQiOjE3OTA2NjQ4MjUsImV4cCI6NDM4MjY2NDgyNX0.SmSIA-duVLN4PAVVpbNjxsGNZrPxN-qB8GrDHvIQtKc';
export const SECONDARY_VALID_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTk4LCJpYXQiOjE3OTA2NjQ4MDIsImV4cCI6NDM4MjY2NDgwMn0.a7YzUXt0uw3An1aaLKEEV92P5eADA0iW7OwR7tpOpSk';

export const AVAILABLE_ACCOUNTS = [
  {
    id: 147,
    userId: 147,
    legacyId: 1,
    channelId: 38,
    name: 'Prathu',
    fullName: 'Prathu',
    username: 'Pratham',
    handle: '@pratham',
    phone: '9876543210',
    email: 'pratham@speedotube.com',
    secondaryEmail: 'creator@speedotube.com',
    initial: 'P',
    avatarBg: '#8a3ffc',
    token: PRIMARY_VALID_TOKEN,
    role: 'Creator & Channel Owner',
    hasChannel: true,
    isMonetized: false,
  },
  {
    id: 198,
    userId: 198,
    legacyId: 3,
    channelId: 40,
    name: 'Aukat Dikhadi',
    fullName: 'Aukat Dikhadi',
    username: 'aukatdikhadi',
    handle: '@aukatdikhadi',
    phone: '9999999999',
    email: 'dikhadiaukat829@gmail.com',
    secondaryEmail: 'explorer@speedotube.com',
    initial: 'A',
    avatarBg: '#009688',
    token: SECONDARY_VALID_TOKEN,
    role: 'Viewer / Creator',
    hasChannel: true,
    isMonetized: false,
  },
];

export function getSavedChannelCustomization(channelId, handle) {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    if (channelId) {
      const byId = localStorage.getItem(`speedotube_customization_id_${channelId}`);
      if (byId) return JSON.parse(byId);
    }
    if (handle) {
      const cleanHandle = (handle.startsWith('@') ? handle : `@${handle}`).toLowerCase();
      const byHandle = localStorage.getItem(`speedotube_customization_${cleanHandle}`);
      if (byHandle) return JSON.parse(byHandle);
    }
  } catch (e) {}
  return null;
}

export function getAvailableAccounts() {
  return AVAILABLE_ACCOUNTS.map((base) => {
    const cached = getSavedChannelCustomization(base.channelId || base.id, base.handle);
    const resolvedName = cached?.name || base.name;
    const resolvedHandle = cached?.handle_name || base.handle;
    const resolvedColor = getAvatarColor(resolvedName || resolvedHandle);
    return {
      ...base,
      name: resolvedName,
      fullName: resolvedName,
      handle: resolvedHandle,
      initial: resolvedName.trim().charAt(0).toUpperCase(),
      avatarBg: resolvedColor,
      avatar_url: cached?.avatar_url || base.avatar_url || '',
      profile_image: cached?.avatar_url || base.profile_image || '',
      banner_url: cached?.banner_url || base.banner_url || '',
    };
  });
}

export function hydrateAccount(acc) {
  if (!acc) return null;
  const email = (acc.email || '').trim().toLowerCase();
  const name = (acc.name || acc.fullName || '').trim().toLowerCase();
  const handle = (acc.handle || '').trim().toLowerCase();

  const isAukat = email === 'dikhadiaukat829@gmail.com' ||
                  email === 'explorer@speedotube.com' ||
                  email.includes('aukat') ||
                  name.includes('aukat') ||
                  name.includes('explorer') ||
                  handle.includes('aukat') ||
                  handle.includes('speedoexplorer') ||
                  acc.id === 198 || acc.userId === 198 || acc.legacyId === 3 || acc.channelId === 40;

  const isPrathu = email === 'pratham@speedotube.com' ||
                   email === 'creator@speedotube.com' ||
                   email.includes('pratham') ||
                   name.includes('pratham') ||
                   name.includes('prathu') ||
                   handle.includes('pratham') ||
                   acc.id === 147 || acc.userId === 147 || acc.legacyId === 1 || acc.channelId === 38;

  if (isAukat) {
    const base = AVAILABLE_ACCOUNTS[1];
    const cached = getSavedChannelCustomization(40, '@aukatdikhadi');
    const isEmailLike = acc.name && (acc.name.includes('@') || acc.name.endsWith('.com'));
    let resolvedName = cached?.name || acc.name || base.name;
    if (acc.name && !isEmailLike && acc.name !== 'Speedo Explorer' && acc.name !== 'Speedo User' && acc.name !== 'User') {
      resolvedName = acc.name;
    }
    const resolvedHandle = cached?.handle_name || (acc.handle && acc.handle !== '@speedoexplorer' ? acc.handle : base.handle);
    const resolvedAvatar = cached?.avatar_url || acc.avatar_url || base.avatar_url || '';
    const resolvedBanner = cached?.banner_url || acc.banner_url || base.banner_url || '';
    const resolvedInitial = (resolvedName && resolvedName.trim()) ? resolvedName.trim().charAt(0).toUpperCase() : 'U';
    return {
      ...base,
      ...acc,
      id: 198,
      userId: 198,
      legacyId: 3,
      channelId: 40,
      name: resolvedName,
      fullName: resolvedName,
      handle: resolvedHandle,
      initial: resolvedInitial,
      avatarBg: getAvatarColor(resolvedName || resolvedHandle),
      avatar_url: resolvedAvatar,
      profile_image: resolvedAvatar,
      banner_url: resolvedBanner,
      token: SECONDARY_VALID_TOKEN,
      email: acc.email || base.email,
    };
  }

  if (isPrathu) {
    const base = AVAILABLE_ACCOUNTS[0];
    const cached = getSavedChannelCustomization(38, '@pratham');
    const isEmailLike = acc.name && (acc.name.includes('@') || acc.name.endsWith('.com'));
    let resolvedName = cached?.name || acc.name || base.name;
    if (acc.name && !isEmailLike && acc.name !== 'Speedo Explorer' && acc.name !== 'Speedo User' && acc.name !== 'User') {
      resolvedName = acc.name;
    }
    const resolvedHandle = cached?.handle_name || (acc.handle && acc.handle !== '@speedoexplorer' ? acc.handle : base.handle);
    const resolvedAvatar = cached?.avatar_url || acc.avatar_url || base.avatar_url || '';
    const resolvedBanner = cached?.banner_url || acc.banner_url || base.banner_url || '';
    const resolvedInitial = (resolvedName && resolvedName.trim()) ? resolvedName.trim().charAt(0).toUpperCase() : 'P';
    return {
      ...base,
      ...acc,
      id: 147,
      userId: 147,
      legacyId: 1,
      channelId: 38,
      name: resolvedName,
      fullName: resolvedName,
      handle: resolvedHandle,
      initial: resolvedInitial,
      avatarBg: getAvatarColor(resolvedName || resolvedHandle),
      avatar_url: resolvedAvatar,
      profile_image: resolvedAvatar,
      banner_url: resolvedBanner,
      token: PRIMARY_VALID_TOKEN,
      email: acc.email || base.email,
    };
  }

  return acc;
}

export function getActiveAccount() {
  if (typeof window !== 'undefined' && localStorage.getItem('speedotube_logged_out') === 'true') {
    return null;
  }
  try {
    const saved = localStorage.getItem('speedotube_user_account') || sessionStorage.getItem('speedotube_user_account');
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed) {
        if (parsed.name === 'Speedo Explorer') {
          parsed.name = 'Aukat Dikhadi';
          parsed.fullName = 'Aukat Dikhadi';
          parsed.handle = '@aukatdikhadi';
          parsed.initial = 'A';
          try {
            localStorage.setItem('speedotube_user_account', JSON.stringify(parsed));
          } catch (e) {}
        }
        const hydrated = hydrateAccount(parsed);
        if (hydrated) {
          const finalName = hydrated.name || hydrated.fullName || '';
          if (finalName.trim()) {
            hydrated.initial = finalName.trim().charAt(0).toUpperCase();
          }
        }
        if (hydrated?.token && typeof window !== 'undefined') {
          const currentToken = localStorage.getItem('speedotube_user_token');
          if (currentToken !== hydrated.token) {
            localStorage.setItem('speedotube_user_token', hydrated.token);
          }
        }
        return hydrated;
      }
    }
  } catch (e) {
    console.warn('Failed to parse active account:', e);
  }

  // Purge any corrupted customization cache keys
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith('speedotube_customization_')) {
          const val = localStorage.getItem(k);
          if (val && (val.includes('Pratu') || val.includes('Prathu') || val.includes('Speedo Explorer'))) {
            localStorage.removeItem(k);
          }
        }
      }
    }
  } catch (e) {}

  // Guest / Signed-Out by default
  return null;
}

export function setActiveAccount(account) {
  if (!account) return;
  try {
    const hydrated = hydrateAccount(account);
    localStorage.removeItem('speedotube_logged_out');
    localStorage.setItem('speedotube_explicit_login', 'true');
    localStorage.setItem('speedotube_user_account', JSON.stringify(hydrated));
    if (hydrated.token) {
      localStorage.setItem('speedotube_user_token', hydrated.token);
    }
    window.dispatchEvent(new CustomEvent('speedotube_user_switched', { detail: hydrated }));
  } catch (e) {
    console.warn('Failed to set active account:', e);
  }
}

/**
 * Checks whether an account or channel is monetized.
 * Monetization is an upcoming, unpublished feature. Currently always returns false.
 */
export function isAccountMonetized() {
  return false;
}

/**
 * Updates monetization state for an account/channel (placeholder for future release).
 */
export function setAccountMonetized() {
  // Unpublished feature
}

/**
 * Resolves the authenticated user's JWT token for SpeedoTube API requests.
 */
export function getActiveUserToken(targetAccount = null) {
  if (typeof window !== 'undefined' && localStorage.getItem('speedotube_logged_out') === 'true') {
    return null;
  }
  const active = targetAccount || getActiveAccount();
  if (active?.token) return active.token;
  const email = (active?.email || '').toLowerCase();
  const name = (active?.name || active?.fullName || '').toLowerCase();
  if (
    email === 'dikhadiaukat829@gmail.com' ||
    email === 'explorer@speedotube.com' ||
    email.includes('aukat') ||
    name.includes('aukat') ||
    name.includes('explorer') ||
    active?.id === 198 ||
    active?.userId === 198 ||
    active?.legacyId === 3 ||
    active?.channelId === 40
  ) {
    return SECONDARY_VALID_TOKEN;
  }
  if (
    email === 'pratham@speedotube.com' ||
    email === 'creator@speedotube.com' ||
    email.includes('prath') ||
    name.includes('prath') ||
    active?.id === 147 ||
    active?.userId === 147 ||
    active?.legacyId === 1 ||
    active?.channelId === 38
  ) {
    return PRIMARY_VALID_TOKEN;
  }
  const stored = typeof window !== 'undefined' ? localStorage.getItem('speedotube_user_token') : null;
  if (stored && stored.length > 20) return stored;
  return null;
}

